
function Footer() {
    return (
        <footer id="rs-footer" className="rs-footer home9-style main-home">
            <div className="footer-bottom">
                <div className="container">
                    <div className="row y-middle">
                        <div className="col-lg-12 md-mb-20">
                            <div className="copyright">
                                <p>&copy; 2024 All Rights Reserved. Developed By <a href="/">CFIITM.</a></p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </footer>
    );
}
export default Footer;